
// Automatic environment detection
const getEnvironment = () => {
  // 1. Check React environment variable (highest priority)
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT;
  }
  
  // 2. Check Node environment
  if (process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  }
  
  // 3. Check hostname patterns
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  } else if (hostname.includes('staging') || hostname.includes('test')) {
    return 'staging';
  } else {
    return 'production';
  }
};

const getDomain = () => {
  const environment = getEnvironment();
  // const hostname = window.location.hostname;
  
  
  // Environment-based URL mapping
  switch (environment) {
    case 'development':
      return 'http://localhost:8080/';
      
    case 'staging':
      return 'https://axel-api-epgzg2c6brbtejhe.centralus-01.azurewebsites.net/';
      
    case 'production':
      return 'https://axel-api-epgzg2c6brbtejhe.centralus-01.azurewebsites.net/';
      
    default:
      console.warn(`⚠️ Unknown environment: ${environment}, defaulting to development`);
      return 'https://axel-api-epgzg2c6brbtejhe.centralus-01.azurewebsites.net/';
  }
};

// Priority order: REACT_APP_BASE_URL > getDomain() > fallback
const BASE_URL = process.env.REACT_APP_BASE_URL || getDomain();


export { BASE_URL }

